import { useTranslate } from "@refinedev/core";

export const useModeOptions = () => {
  const translate = useTranslate();

  const getModeOptions = () => [
    { value: "", label: translate("options.none") },
    { value: "online", label: translate("options.modes.online") },
    { value: "local", label: translate("options.modes.offline") }
  ];

  return { getModeOptions };
};
